<script setup lang="ts">
import { inject, ref } from 'vue'
import { AppSettingsKey } from './../../types/keys'
import type { AppSettings } from '../../types'

const isSearching = ref<boolean>(false)
const searchTerm = ref<string>('')
const { resourceStrings } = inject(AppSettingsKey) as AppSettings

const emit = defineEmits<{
  onDepartureSearch: [term: string]
  onSearchCleared: []
}>()

function onSearch(): void {
  if (searchTerm.value) {
    isSearching.value = true
    emit('onDepartureSearch', searchTerm.value)
  }
}

function onClear(): void {
  searchTerm.value = ''
  isSearching.value = false
  emit('onSearchCleared')
}

function handleInput(): void {
  if (!searchTerm.value) {
    onClear()
  }
}

function handleInputBlur(): void {
  if (!searchTerm.value) {
    onClear()
  }
}
</script>
<template>
  <div class="departure_board__search">
    <div class="departure-search">
      <div class="departure-search__form">
        <div class="departure-search__bar">
          <label for="f-search" class="show-for-sr">{{
            resourceStrings['TravelUpdates.Labels.Sr.Search']
          }}</label>
          <div class="departure-search__controls">
            <input
              v-model="searchTerm"
              v-on:keyup.enter="onSearch"
              @input="handleInput"
              @blur="handleInputBlur"
              data-departure-board-search=""
              class="departure-search__input"
              type="text"
              id="f-search"
              name="departure-search"
              autocomplete="off"
              :placeholder="
                resourceStrings['TravelUpdates.Placeholders.EnterBoardingCode']
              "
              :title="resourceStrings['TravelUpdates.Labels.Sr.Search']"
            />
            <button
              v-if="isSearching"
              @click="onClear"
              class="departure-search__button departure-search__button--clear"
              :aria-label="resourceStrings['TravelUpdates.Buttons.Clear']"
            >
              <svg>
                <use xlink:href="#svg-close-small"></use>
              </svg>
            </button>
            <button
              @click="onSearch"
              class="btn btn--sm btn--vt-key departure-search__button"
            >
              {{ resourceStrings['TravelUpdates.Buttons.Search'] }}
              <svg class="btn__icon">
                <use xlink:href="#svg-button-arrow"></use>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
